export default __webpack_public_path__ + "static/media/mastercard_logo_icon.4b809b97.svg";